<template>
    <div v-if="nb_remaining_late_by_timestamp > 0">
        <h6>Coureurs {{ very_late ? 'très en retard (plus de 1h)' : 'en retard' }} <b-badge
                class="bg-red-500 text-white">{{ nb_remaining_late_by_timestamp }}</b-badge>
        </h6>
        <div>Basé sur leur heure de passage estimée</div>
        <b-table id="table-remaining-late" :items="coureurs" :fields="fields" :per-page="perPageLate"
            :current-page="currentPageLate">
            <template #cell(estimation)="row">
                {{ get_difference_time(row.item.timestamp) }}
            </template>
            <template #cell(coureur)="row">
                {{ row.item.coureur }}
            </template>
            <template #cell(fiche)="row">
                <button class="inline-btn py-1 my-0" @click="openFicheCoureur(row.item.id_coureur)"><b-icon
                        icon="person" aria-hidden="true"></b-icon> Ouvrir sa fiche</button>
            </template>
        </b-table>
        <b-pagination v-model="currentPageLate" :total-rows="nb_remaining_late_by_timestamp" :per-page="perPageLate"
            aria-controls="table-remaining-late" size="sm" class="mt-2"></b-pagination>
    </div>
</template>

<script>
import moment from 'moment';
export default {
    props: ['coureurs', 'very_late'],
    data() {
        return {
            currentPageLate: 1,
            perPageLate: 5,
            fields: [
                { key: 'estimation', label: 'Estimation' },
                { key: 'coureur', label: 'Coureur' },
                { key: 'fiche', label: 'Fiche' },
            ]
        }
    },
    computed: {
        nb_remaining_late_by_timestamp() {
            if (!this.coureurs) {
                return 0;
            }
            return this.coureurs.length;
        }
    },
    methods: {
        openFicheCoureur(idCoureur) {
            // ouvrir nouvel onglet
            var fiche_path = "fiche/" + idCoureur;
            window.open(fiche_path, '_blank');
        },
        get_difference_time(timestamp) {
            //timestamp is a unix timestamp
            var date = new Date(timestamp * 1000);
            return "Attendu " + moment(date).fromNow();
        }
    }
}
</script>

<style lang="scss" scoped></style>